<template lang="pug">
#event-tooltip.scrim(
	v-if="props.eventDetail"
	@click.self="closeDetail"
)
	.card(:style="{'--bkg-color': calColor}")
		.header
			.close(@click="closeDetail")
				include ../../resources/icons/close.svg
		.contents
			.title {{ props.eventDetail.event.title }}
			.underline
			.date-time(v-if="!endTime") {{ startDate }} - {{ endDate }}
			.date-time(v-if="endTime")
				.date-time {{ startDate }}
				.date-time {{ startTime }} - {{ endTime }}
			.dog(v-if="dogInfo")
				p Dog's name: {{ dogInfo.name }}
				p(v-if="ownerName") Owner's name: {{ ownerName }}
				p Dog's size: {{ dogInfo.size }}
				p Dog's weight: {{ dogInfo.weight }}
				p Dog's breed: {{ dogInfo.breed }}
				p Dog's ID: {{ dogInfo.$id }}
				p Owner's ID: {{ dogInfo.owner }}

</template>

<script setup lang="ts">

import { Events, Userspaces } from "@busy-human/k9-library";
import { computed, onMounted, ref } from "vue";
import { useUserspace } from "@/store/useUsers";
import type { DataInstance } from "@busy-human/gearbox";

type AugmentedEvent = {
	event: Events.Model
	startColumn: number
	endColumn: number
	startsBefore: boolean
	endsAfter: boolean
	backgroundColor?: string
	foregroundColor?: string
};

type Props = {
	eventDetail: null | AugmentedEvent,
	dogInfo: any | null,
};

type Emits = {
	(e: 'close:selectedEvent'): void;
};

const emit = defineEmits<Emits>();

const props = withDefaults(defineProps<Props>(), {
	"eventDetail" : null,
	"dogInfo"     : null,
});

const closeDetail = () => {
	console.log("props.eventDetail = null");
	emit('close:selectedEvent');
};


const userStore = useUserspace();
const ownerRef = userStore.asArray;

const ownerName = ref("");

const getOwnerName = () => {
	if(props.dogInfo.owner) {
		const ownerID = props.dogInfo.owner;
		const ownerInfo = ownerRef.filter(owner => owner.$id === ownerID);
		console.log("LOOK:", ownerInfo);

		ownerName.value = ownerInfo.map((item)=>item.name.fullName).toString();
	}
};



const calColor  = ref<string>("#2288ff");
const startDate = ref("");
const startTime = ref("");
const   endDate = ref("");
const   endTime = ref("");

const getDisplayDate = () => {
	const currentOffset = new Date().getTimezoneOffset();
	if (props.eventDetail?.event?.startTime){
		const startOffsetted = new Date(props.eventDetail.event.startTime);
		const endOffsetted = new Date(props.eventDetail.event.endTime);

		startOffsetted.setMinutes(currentOffset);
		endOffsetted.setMinutes(currentOffset);

		startDate.value = new Date(startOffsetted).toLocaleDateString([], {month: "short", day: "numeric", year: "numeric" });
		endDate.value =   new Date(endOffsetted  ).toLocaleDateString([], {month: "short", day: "numeric", year: "numeric" });
		if('eventType' in props.eventDetail.event && props.eventDetail.event.eventType === 'pickup-dropoff'){
			startTime.value = new Date(props.eventDetail?.event.startTime).toLocaleTimeString([], {hour: "numeric", minute: "numeric"});
			endTime.value =   new Date(props.eventDetail?.event.endTime  ).toLocaleTimeString([], {hour: "numeric", minute: "numeric"});
		}
	}
};


onMounted(()=>{
	getDisplayDate();
	calColor.value = props.eventDetail?.backgroundColor || "#88ff88";
	console.info(" PROPSP : ", props.eventDetail,
		"\n \n \n ---  props . dog info: ",props.dogInfo,
		"\n \n \n ---  start date: ", startDate,
		"\n \n \n ---  end date: ", endDate,
	);
	getOwnerName();
});

</script>

<style lang="scss" >
#event-tooltip.scrim{
	position: fixed;
	top: 0;
	left:  0;
	z-index:  55;
	display: flex;
	align-items:  center;
	justify-content: center;
	width: 100%;
	height: 100%;
	background: #00000005;

	.card::before{
		position: absolute;
		top:  8px;
		left: 8px;
		z-index: -5;
		display: block;
		width: 100%;
		height: 100%;
		content: '';
		background: var(--bkg-color);
	}

	.card{
		position: relative;
		width: fit-content;
		min-width: 15rem;
		height: fit-content;
		min-height: 10rem;
		font-size: 1.25rem;
		color: $color-black;
		background:  $color-white;
	}

	.card, .card::before{
		border: 2px solid $color-black;
	}

	.close{
		position: absolute;
		top:   0;
		right: 0;
		width:   1.5rem;
		height:  1.5rem;
		padding: 0.25rem;

	}

	.close:hover{
		cursor: pointer;
	}

	.title{
		padding-bottom: 1rem;
		font-size: 1.5rem;
		border-bottom: 4px solid var(--bkg-color);
	}

	// .underline{
	// 	display: block;
	// 	width: 100%;
	// 	height: 2px;
	// 	background-color: var(--bkg-color);
	// }

	.date-time{
		// font-size: 0.75rem;
		margin-block: 1rem;
		line-height: 2em;
		color: rgba($color-black, 0.8);
	}

	// .header{
	// 	width: 100%;
	// 	height: 0;
	// 	background-color: var(--bkg-color);
	// }

	.contents{
		display: grid;
		grid-template-rows: repeat(auto-fill, minmax(1rem, 3rem));
		grid-template-columns: 100%;
		grid-auto-flow: row;
		align-items: center;
		justify-content: center;
		height: 100%;
		padding: 2rem;
	}

	.dog{
		padding: 0.5rem;
		border: 1px solid $color-black;
		box-shadow: 4px 4px  var(--bkg-color);
	}
}

</style>